import { useCallback, useEffect, useState } from 'react'
import { getEvidenceCount } from '../visionApi'

/**
 * Story 213, C17.10 — how many phone images Sun has available, for "Delete all images". Asked on opening and again after a
 * deletion (`refresh`); while unknown or on a failure it is 0, so nothing can be deleted by mistake.
 */
const useEvidenceCount = () => {
  const [available, setAvailable] = useState(0)

  const refresh = useCallback(() => getEvidenceCount()
    .then((answer) => setAvailable(answer && typeof answer.available === 'number' ? answer.available : 0))
    .catch(() => setAvailable(0)), [])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { available, refresh }
}

export default useEvidenceCount
